import React, { useState, useEffect } from 'react';
import {
    CButton, CRow, CCol, CCard, CCardBody, CTab, CTabContent, CTabList, CTabPanel, CTabs, CHeader, CContainer, CHeaderNav, CNavItem, CNavLink, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow
} from '@coreui/react';
import { FaEdit, FaSearch } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsTrash3 } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import Doctorvector from '../../../assets/images/doctorvector.png';
import Adminprofil from '../../../assets/images/adminprofil.png';
import AddStaffModal from './adduserstaff';
import { ToastContainer, toast } from 'react-toastify';
import EditStaffModal from './edituserstaff';
import api from '../../../service/caller';
import { useNavigate, useLocation } from 'react-router-dom';

import '@coreui/coreui/dist/css/coreui.min.css';
import '@coreui/coreui/dist/js/coreui.bundle.min.js';

import { usePermissions } from '../../../contexts/PermissionContext';

const StaffList = () => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [modalValue, setModalValue] = useState(null);
    const [isEditModalVisible, setEditModalVisible] = useState(false);
    const [staffs, setStaffs] = useState([]);
    const [activeRole, setActiveRole] = useState("Allusers");
    const [myHospitalUser, setMyHospitalUser] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [roles, setRoles] = useState([]);

    // Search state
    const [searchTerm, setSearchTerm] = useState('');

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    const [selectedUser, setSelectedUser] = useState(null);
    const { hasPermission, userData, loading } = usePermissions();

    const [UserData, setUserData] = useState([]);
    const [HospitalsList, setHospitalsList] = useState([]);

    useEffect(() => {
        const fetchHospitalsList = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const response = await api.get(`api/hospitals/admin/${token}`);
                const hospitalIds = response.data.map(hospital => hospital._id).join(',');
                fetchMyHospitalUser(hospitalIds);
                setHospitalsList(response.data);
            } catch (error) {
                toast.error(error);
                console.error("Error fetching Hospitals List:", error);
            }
        };

        const fetchMyHospitalUser = async (hospitalIds) => {
            try {
                const response = await api.get(`api/usersbydepartment?hospital_id=${hospitalIds}`);
                const users = response.data;
                setMyHospitalUser(users);
                setFilteredUsers(users);
                setTotalItems(users.length);
            } catch (error) {
                toast.error("Error fetching hospital users");
                console.error("Error fetching Hospital Users", error);
            }
        };

        const fetchRoles = async () => {
            try {
                const response = await api.get('api/getallroles');
                setRoles(response.data);
            } catch (error) {
                toast.error("Error fetching roles");
                console.error("Error fetching Roles:", error);
            }
        };

        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };

        fetchHospitalsList();
        fetchLoggedUserData();
        fetchRoles();
    }, []);

    // Apply search and filtering when these dependencies change
    useEffect(() => {
        let result = [...myHospitalUser];

        // Apply role filter
        if (activeRole !== "Allusers") {
            result = result.filter(user => user.role?._id === activeRole);
        }

        // Apply search filter
        if (searchTerm) {
            const searchLower = searchTerm.toLowerCase();
            result = result.filter(user =>
                (user.firstname && user.firstname.toLowerCase().includes(searchLower)) ||
                (user.lastname && user.lastname.toLowerCase().includes(searchLower)) ||
                (user.phone && user.phone.includes(searchTerm)) ||
                (user._id && user._id.includes(searchTerm))
            );
        }

        setFilteredUsers(result);
        setTotalItems(result.length);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchTerm, activeRole, myHospitalUser]);

    const refreshHospitalUsers = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await api.get(`api/hospitals/admin/${token}`);
            const hospitalIds = response.data.map(hospital => hospital._id).join(',');

            const usersResponse = await api.get(`api/usersbydepartment?hospital_id=${hospitalIds}`);
            setMyHospitalUser(usersResponse.data);
        } catch (error) {
            toast.error("Error refreshing hospital users");
            console.error("Refresh error:", error);
        }
    };

    const handleButtonClick = (value) => {
        setModalValue(value !== 'Allusers' ? value : "Allusers");
        setVisible(true);
    };

    const handleStaffAdded = (newStaff) => {
        setStaffs((prev) => [...prev, newStaff]);
        refreshHospitalUsers();
    };

    const handlePageChange = (page) => {
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleEditClick = (user) => {
        setSelectedUser(user);
        setEditModalVisible(true);
    };

    const handleDetailsClick = (id) => {
        navigate({
            pathname: '/hospitaladmin/staff_details',
            search: `?_id=${id}`
        });
    };

    const handleScheduleClick = (id) => {
        navigate({
            pathname: '/hospitaladmin/staff_schedule_edit',
            search: `?_id=${id}`
        });
    };

    const handleDeleteUserClick = async (id) => {
        try {
            const response = await api.delete('api/users/' + id);
            if (response.status === 200 || response.status === 201) {
                toast.success("Staff Deleted successfully!");
                refreshHospitalUsers();
            } else {
                toast.error(response.data.message || "Failed to delete staff. Please try again.");
            }
        } catch (error) {
            toast.error(`Registration failed: ${error?.response?.data?.message || 'An unexpected error occurred. Please try again.'}`);
            console.error('Error:', error?.response || 'No error message available.');
        }
    };

    const handleStaffUpdated = () => {
        refreshHospitalUsers();
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleStatusChange = async (userId, currentStatus) => {
        const newStatus = currentStatus === 'active' ? 'deactivated' : 'active';
        try {
            await api.post('/api/updateUserStatus', {
                userId,
                status: newStatus,
            });

            toast.success("Status successfully Updated!");
            setMyHospitalUser(prevUsers =>
                prevUsers.map(user =>
                    user._id === userId ? { ...user, status: newStatus } : user
                )
            );
        } catch (err) {
            console.error('Erreur lors du changement de statut', err);
        }
    };

    // Get current users for pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const renderActionDropdown = (user) => (
        <div className="actionbtn">
            <div className="left">
                <div className="dropdown-center p-0 bg-none" style={{ border: 'none' }}>
                    <FaEdit
                        className="bg-none border-0 p-0"
                        data-coreui-toggle="dropdown"
                        aria-expanded="true"
                        style={{ border: 'none' }}
                    />
                    <ul className="dropdown-menu">
                        <li>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => handleEditClick(user)}
                            >
                                Edit
                            </a>
                        </li>
                        <li>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    const confirmText = user?.status === 'active'
                                        ? 'Are you sure you want to deactivate this user?'
                                        : 'Are you sure you want to activate this user?';
                                    if (window.confirm(confirmText)) {
                                        handleStatusChange(user?._id, user?.status);
                                    }
                                }}
                            >
                                {user?.status === 'active' ? 'Deactivate' : 'Activate'}
                            </a>
                        </li>
                        <li>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => handleDetailsClick(user?._id)}
                            >
                                View Details
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="right">
                <div className="dropdown-center p-0 bg-none" style={{ border: 'none' }}>
                    <BsTrash3
                        style={{ color: '#EF3826', border: 'none' }}
                        className="bg-none border-0 p-0"
                        data-coreui-toggle="dropdown"
                        aria-expanded="true"
                    />
                    <ul className="dropdown-menu" style={{ color: '#EF3826', borderRadius: '25px' }}>
                        <li>
                            <a
                                className="dropdown-item text-center"
                                style={{
                                    borderBottom: '1px solid #979797',
                                    maxWidth: '100%',
                                    wordBreak: 'break-word',
                                    whiteSpace: 'normal'
                                }}
                                href="#"
                            >
                                Are you sure you want to delete this user?
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item my-3" href="#">
                                <button
                                    className="btn mx-2"
                                    style={{ backgroundColor: '#000', color: 'white' }}
                                >
                                    No
                                </button>
                                <button
                                    className="btn mx-2"
                                    style={{ backgroundColor: '#ff0000', color: 'white' }}
                                    onClick={() => handleDeleteUserClick(user?._id)}
                                >
                                    Delete
                                </button>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );

    const commonTableColumns = [
        {
            key: 'profile', label: 'Profile', render: user => (
                <img src={user?.picture || Doctorvector} className="cardicon" alt="Consultation Icon" width="50" height="50" />
            )
        },
        { key: 'name', label: 'Name', render: user => `${user?.firstname} ${user?.lastname}` },
        { key: 'role', label: 'Fonction', render: user => user?.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ') ?? 'Undefined' },
        {
            key: 'department',
            label: 'Department',
            render: user => user.departementId?.map(dep => dep.name).join(', ') || 'No Department'
        },

        {
            key: 'status', label: 'Status',
            render: user => {
                const statusClass = user.status === 'active' ? 'coloredsucess' : 'coloredechec';
                const capitalized = user.status.charAt(0).toUpperCase() + user.status.slice(1);
                return <span className={statusClass}>{capitalized}</span>;
            }
        },
        { key: 'actions', label: 'Action', render: user => renderActionDropdown(user) }
    ];

    const renderTable = (users, roleId) => (
        <>

            <div className='row'>
                <div className="col-lg-9 mb-4">
                    <div className="search-container w-100">
                        <div className="search-bar">
                            <FaSearch
                                className="search-icon"
                                style={{ width: '20px', height: '20px' }}
                            />
                            <input
                                type="text"
                                placeholder="Search for a user (Enter ID, name or Tel)"
                                className='ms-4 w-100'
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 mb-4">
                    <div className="">
                        {hasPermission('medtinz_client_staff_create') && (
                            <CButton
                                onClick={() => handleButtonClick(roleId)}
                                className="btn btn-primary w-100"
                                style={{
                                    backgroundColor: '#0056B3',
                                    color: 'white',
                                    width: '100%',
                                    padding: '10px 20px',
                                    borderRadius: '25px'
                                }}
                                active
                                tabIndex={-1}
                            >
                                <BsPersonPlus className="mx-2" /> Register New User
                            </CButton>
                        )}
                    </div>
                </div>
            </div>

            <CTable hover className='mt-5' align="middle" responsive>
                <CTableHead>
                    <CTableRow>
                        {commonTableColumns.map(col => (
                            <CTableHeaderCell key={col.key}>{col.label}</CTableHeaderCell>
                        ))}
                    </CTableRow>
                </CTableHead>
                <CTableBody>
                    {users.length > 0 ? (
                        users.map((user, index) => (
                            <CTableRow key={index}>
                                {commonTableColumns.map(col => (
                                    <CTableDataCell key={col.key}>
                                        {col.render(user)}
                                    </CTableDataCell>
                                ))}
                            </CTableRow>
                        ))
                    ) : (
                        <CTableRow>
                            <CTableDataCell colSpan={commonTableColumns.length} className="text-center">
                                No users found matching your criteria
                            </CTableDataCell>
                        </CTableRow>
                    )}
                </CTableBody>
            </CTable>

            <AddStaffModal
                visible={visible}
                onClose={() => setVisible(false)}
                handleStaffAdded={handleStaffAdded}
                setVisible={setVisible}
                modalValue={modalValue}
                handleButtonClick={handleButtonClick}
            />
        </>
    );

    return (
        <div className="dashboard-header">
            <ToastContainer />
            <EditStaffModal
                visible={isEditModalVisible}
                onClose={() => setEditModalVisible(false)}
                onStaffUpdated={handleStaffUpdated}
                user={selectedUser}
            />

            {/* <div className='row px-4'>
                <div className='col-lg-4 mb-3'>
                    <div className="pagetittle">
                        <h4 className=' text-start'><b>Staff Management</b></h4>
                    </div>
                </div>
                <div className='col-lg-4'></div>
                <div className='col-lg-4 mx-auto'>
                    <div className="d-flex justify-content-end gap-4">
                        <div>
                            <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                        </div>
                        <div>
                            <span className="ms-2">{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2">{UserData.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}</p>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
                <div className="hosp-header__content">
                    {/* Titre à gauche */}
                    <div className="hosp-header__title">
                        <h4 className="hosp-page__title"><b>Staff Management</b></h4>
                    </div>

                    {/* Profil utilisateur à droite */}
                    <div className="hosp-user__profile">
                        {/* Indicateur de statut en ligne (optionnel) */}
                        <div className="hosp-status__indicator"></div>

                        <img src={UserData?.picture || Adminprofil} className='hosp-profile__image'  alt="Consultation Icon"  />

                        <div className="hosp-user__details">
                            <span className="ms-2">{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2">{UserData.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}</p>
                        </div>
                    </div>
                </div>
            </div>



            <div className="Patientlist mt-4">
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <CTabs activeItemKey={activeRole} onTabChange={setActiveRole}>
                                        <CTabList variant="underline" className="border-bottom">
                                            <CTab itemKey="Allusers">All Users</CTab>
                                            {roles
                                                .filter(role => !['medtinz_client_patient', 'medtinz_client_hospital_settings'].includes(role.name))
                                                .map((role) => (
                                                    <CTab
                                                        itemKey={role._id}
                                                        key={role._id}
                                                        disabled={['medtinz_client_laboratory', 'medtinz_client_pharmacist'].includes(role.name)}
                                                    >
                                                        {role.name.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}
                                                    </CTab>
                                                ))
                                            }
                                        </CTabList>
                                        <CTabContent>
                                            <CTabPanel className="p-3" itemKey="Allusers">
                                                {renderTable(currentItems)} {/* Affiche tous les utilisateurs filtrés par la recherche */}
                                            </CTabPanel>
                                            {roles
                                                .filter(role => ![
                                                    'medtinz_client_patient',
                                                    'medtinz_client_hospital_settings'
                                                ].includes(role.name))
                                                .map((role) => (
                                                    <CTabPanel key={role._id} className="p-3" itemKey={role._id}>
                                                        {renderTable(filteredUsers.filter(user => user.role?._id === role._id), role._id)}
                                                        {/* Filtre filteredUsers pour afficher uniquement les utilisateurs avec le rôle correspondant */}
                                                    </CTabPanel>
                                                ))}
                                        </CTabContent>
                                    </CTabs>

                                    {/* Pagination */}
                                    {totalItems > 0 && (
                                        <div className='paginate me-5'>
                                            <p className='mt-3'>
                                                Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, totalItems)} of {totalItems}
                                            </p>
                                            <div className='actionbtn'>
                                                <div className='left'>
                                                    <BsChevronLeft
                                                        className={`pagicon ${currentPage === 1 ? 'text-muted' : ''}`}
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        style={{
                                                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                                            opacity: currentPage === 1 ? 0.5 : 1
                                                        }}
                                                    />
                                                </div>
                                                <div className='right'>
                                                    <BsChevronRight
                                                        className={`pagicon ${currentPage === totalPages ? 'text-muted' : ''}`}
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        style={{
                                                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                                            opacity: currentPage === totalPages ? 0.5 : 1
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>
        </div>
    );
};

export default StaffList;